import admin from './admin';
import affiliate from './affiliate';
import auth from './auth';
import billing from './billing';
import bulkEdit from './bulkEdit';
import bulkPhotoEditor from './bulkPhotoEditor';
import connectProfile from './connectProfile';
import data from './data';
import edit from './edit';
import listings from './listings';
import mediaLibrary from './mediaLibrary';
import notifications from './notifications';
import photoEditor from './photoEditor';
import profiles from './profiles';
import profilesV2 from './profilesV2';
import scheduledUpdates from './scheduledUpdates';
import shops from './shops';
import user from './user';

const reducers = {
  admin,
  affiliate,
  auth,
  billing,
  bulkEdit,
  bulkPhotoEditor,
  connectProfile,
  data,
  edit,
  listings,
  mediaLibrary,
  notifications,
  photoEditor,
  profiles,
  profilesV2,
  scheduledUpdates,
  shops,
  user,
};

export function* reducer(state, action) {
  const { type, payload } = action;
  const name = type.split('.')[0];

  if (name in reducers && type in reducers[name] && typeof reducers[name][type] === 'function') {
    return yield* reducers[name][type](state, payload);
  } else {
    return state;
  }
}
